import { render, staticRenderFns } from "./template.html?vue&type=template&id=0c1d22ef&scoped=true&"
import script from "./DetailPhotos.vue?vue&type=script&lang=js&"
export * from "./DetailPhotos.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=0c1d22ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1d22ef",
  null
  
)

export default component.exports